import { NgForm, FormsModule } from '@angular/forms';
import { Component, PLATFORM_ID, HostListener, Inject } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import {HttpClient, HttpClientModule,HttpHeaders,} from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { WebService } from '../services/web.service';
import swal from 'sweetalert2';
import {FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { ApidataService } from '../apidata.service';
import { Http } from '@angular/http';
import { ReactiveFormsModule } from '@angular/forms'
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment, GINConstants } from '../../environments/environments';

export class PasswordValidation {
    static MatchPassword(AC: AbstractControl) {
        const password = AC.get('password').value; 
        const confirmPassword = AC.get('confirmPassword').value; 
        if (password !== confirmPassword) {
            AC.get('confirmPassword').setErrors({ MatchPassword: true });
        } else {
            return null;
        }
    }
}


declare var $: any;
declare interface ValidatorFn {
  (c: AbstractControl): {
    [key: string]: any;
  };
}
declare interface User {
  text?: string; 
  email?: string; 
  password?: string; 
  confirmPassword?: string; 
  number?: number; 
  url?: string;
  idSource?: string;
  idDestination?: string;
  optionsCheckboxes?: boolean;
}
@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [RecaptchaModule, HttpClientModule, CommonModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {
  public typeValidation: User;
  register: FormGroup;
  login: FormGroup;
  hide=true;
  hide1 =true;
  type: FormGroup;
  endRequest;
  model: any = {};
  param;
  code;
  reset_password_code
  reset_password;
  new_password;
  repeat_password;
  dangerAlerts;
  old_password;
  color;
  esubText3:boolean = false ;
  authentication_token;
  recaptcha_message = ""
  got_recpatcha : boolean = false;
  captchaToken: string | null = null; 
  public nodata: boolean = false;
  captchaResponse: string;

  password_regex = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[\/\\\!\"#$%&()*+,£^.:;=?\\\\[\\]\\-\'<>~|@_{}]).{8,}$';

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
   private Title: Title, private meta: Meta,
    private apiservice: ApidataService,) {
  
      localStorage.clear();
      }
      ngOnInit() {
        $(document).on('click', '.toggle-password7', function() {

          $(this).toggleClass("fa-eye fa-eye-slash");

          var input = $("#pass_log_id7");
          input.attr('type') === 'password' ? input.attr('type','text') : input.attr('type','password')
        });
        $(document).on('click', '.toggle-password8', function() {

          $(this).toggleClass("fa-eye fa-eye-slash");

          var input = $("#pass_log_id8");
          input.attr('type') === 'password' ? input.attr('type','text') : input.attr('type','password')
        });        
        this.endRequest = this.param = this.route.params.subscribe(params => {
          this. reset_password_code = params['query2'];

        });
        this.register = this.formBuilder.group({
        
          password: ['', Validators.compose([Validators.required,  Validators.minLength(8), Validators.maxLength(100)])],
          confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(100)])],
          old_password: [''],

        }, {
            validator: PasswordValidation.MatchPassword 
          });
      }

      onCaptchaResolved(captchaResponse: string) {
        this.captchaResponse = captchaResponse;
      }
  onForget() {
    this.reset_password= $('#pass_log_id7').val();
    this.repeat_password =  $('#pass_log_id8').val();

    var reg = /^[A-Za-z]\w{8,14}$/;
   
      if(this.reset_password === '' || this.repeat_password === ''){
        this.showAlert("Please provide the required fields.","");
      }
     else if( (this.reset_password && this.repeat_password) && this.repeat_password !== this.reset_password){
        this.showAlert("Password and Confirm password fields should be same.","");
      }
      else if( this.reset_password.length<8 ){
        this.showAlert("Password must be 8 characters long.","");
      }
    
      else if ((this.reset_password && this.repeat_password) && (this.repeat_password === this.reset_password)){


      this.endRequest = this.apiservice.change_password( this. reset_password_code, this.register.value['password']).subscribe(
          data => {
         

            if(data['response'].updated_password_message){
            swal({
              type: 'success',
              title: 'Password has been updated',
              showConfirmButton: false,
              timer: 3500,width: '512px',
            })
            this.router.navigate(['/signin'])
          }
          else if(data['response'].Invalid_confirmation_code_message){
            swal({
              type: 'error',
              title: 'Link Expired',
              showConfirmButton: false,
              timer: 3500,width: '512px',
            })

          }
          else if(data['response'].old_password_message){
            swal({
              type: 'error',
              title: 'You have entered an old password. Please try another one',
              showConfirmButton: false,
              timer: 3500,width: '512px',
            })
          }
          },
          error => { });

      }
    }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  showAlert(message, selector) {
    this.color = '#721c24';
    this.dangerAlerts = message;
    this.esubText3 = true;
    $(selector).css('border-color', 'red')
    $('#dangerAlerts').show();
    setTimeout(() => {
      $('#dangerAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.esubText3 = false;
    }, 4000);
  }
  ngOnDestroy() {
  }
  public ngAfterViewInit(): void {
    this.loadTurnstileScript().then(() => this.renderTurnstile());}


loadTurnstileScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window['turnstile'] !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Failed to load Turnstile script');
    document.body.appendChild(script);
  });
}

renderTurnstile(): void {
  if (typeof window['turnstile'] !== 'undefined') {
    window['turnstile'].render('#recaptcha-container', {
      sitekey: environment.CaptchaKey, 
      size: 'normal',  
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });

  } else {
    // console.error('Turnstile script not loaded.');
  }
}

// Button click handler to execute Turnstile
handleButtonClick(event: Event): void {
  event.preventDefault();

  if (!this.captchaToken) {
  
    this.got_recpatcha = true;
    $('#dangerAlert').html('Captcha is not loaded. Please reload the page.');
    $('#dangerAlert').show();
    this.nodata = true;

    setTimeout(() => {
      $('#dangerAlert').hide();
    }, 3000);

    return; 
  }
  this.got_recpatcha = false;
  this.onForget();
}

// Success callback when the CAPTCHA is solved
onTurnstileSuccess(token: string): void {
  // console.log('Turnstile token received:', token);
  this.captchaToken = token;  
}

// Error callback when CAPTCHA fails
onTurnstileError(): void {
  // console.error('Turnstile error occurred.');
  this.captchaToken = null; 
}


///// recaptcha end
}

